<template>
  <div v-if="!loading" style="background-color: #f5f5f5">
    <van-tabs
      class="vantabs"
      v-model="active"
      animated
      swipeable
      color="#2E94E5"
      line-height="3px"
      title-active-color="#2E94E5"
    >
      <van-tab v-for="item in navData" :title="item.text">
        <component
          v-if="item.data != ''"
          :is="item.url"
          :list.sync="item.data"
        ></component>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import Organ from "@/components/Organ"
import Summary from "@/components/Summary"
import Physiology from "@/components/Physiology"
import Brain from "@/components/Brain"
import Diabetes from "@/components/Diabetes"
import Healthy from "@/components/Healthy"
import Report from "../models/Report"
export default {
  components: { Summary, Physiology, Brain, Diabetes, Healthy, Organ },
  data () {
    return {
      active: 0,
      loading: true,
      navData: [
        { text: '健康概况', url: 'Organ', list: 'organ' },
        { text: '健康总评', url: 'Summary', list: 'summary' },
        { text: '生理系统风险', url: 'Physiology', list: 'physiology' },
        { text: '脑血管风险', url: 'Brain', list: 'brain' },
        { text: '糖尿病风险', url: 'Diabetes', list: 'diabetes' },
        { text: '健康管理建议', url: 'Healthy', list: 'healthy' }],
    }
  },
  computed: {
    id () {
      return this.$route.query.id || ''
    },
    user_no () {
      return this.$route.query.user_no || ''
    }
  },
  methods: {
    oylstatus (status) {
      let level;
      switch (status) {
        case 1:
          level = 5
          break;
        case 2:
          level = 4
          break;
        case 3:
          level = 3
          break;
        case 4:
          level = 2
          break;
        case 5:
          level = 1
          break;
      }
      return level
    }
  },
  created () {
    let params = {
      user_no: this.user_no,
      test_report_id: this.id
    }
    Report.getReports({ ...params }, (res, err) => {
      this.loading = true
      if (!err) {
        res.healthy.forEach(e => {
          e.btntxt = "查看建议";
          e.showCon = false
        });
        res.special[0].descArr = res.special[0].desc.split('\\r\\n');
        res.special[1].descArr = res.special[1].desc.split('\\r\\n')
        res.diabetes.descArr = res.diabetes.diabetes_desc.split('\\r\\n');
        res.brain.descArr = res.brain.brain_desc.split('\\r\\n');
        res.special[4].status = this.oylstatus(res.special[4].status)
        for (let key in res.physiology_system) {
          res.physiology_system[key].forEach(e => {
            e.showDetail = false;
            e.remakrs = e.remakrs ? e.remakrs.split('\\r\\n') : []
          })
        }
        console.log('adsfa', res.special[0])
        this.navData[0].data = res;
        this.navData[1].data = res.special;
        this.navData[2].data = {
          ...res.physiology,
          physiology_system: res.physiology_system
        };
        this.navData[3].data = res.brain;
        this.navData[4].data = res.diabetes;
        this.navData[5].data = {
          healthy: res.healthy,
          marks: res.marks
        }
        if (res.is_show_survey === 1) {
          this.navData.splice(1, 5);
        }
        this.loading = false
      }
    })
  }
}
</script>
<style lang="scss" >
.van-tabs--line .van-tabs__wrap {
  height: 80px !important;
  line-height: 80px;
  margin-bottom: 20px;
}
.van-tabs__wrap--scrollable .van-tab {
  flex: 0 0 30% !important;
  font-size: 30px;
}
.vantabs {
  font-size: 30px;
}
</style>